import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { PosterImage } from "./image.js";
import { PosterRoot } from "./root.js";
//#region src/ui/poster/index.parts.ts
var index_parts_exports = /* @__PURE__ */ __exportAll({
	Image: () => PosterImage,
	Root: () => PosterRoot
});
//#endregion
export { PosterImage as Image, PosterRoot as Root, index_parts_exports };

//# sourceMappingURL=index.parts.js.map